var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.flag == '快递单')?_c('order',{on:{"getOrde":_vm.getOrderFlag}}):(_vm.flag == '发货单')?_c('deliverGoods',{on:{"getDelGoods":_vm.getDelGoodsFlag}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }